<template>
  <div class="row">
    <div class="col-12 col-sm-7">
      <label :for="`drinkset-${drinkSet.id}`">
        {{drinkSet.name}}
      </label>
      <br>
      <span class="drink-set-content" @click="show" style="text-decoration: underline;"><i class="fa fa-plus-circle"></i>ドリンク内容</span>
      <Modal title="ドリンク内容" v-if="shouldShowDrinkSetModal" @close="hide">
        <div class="col-12" v-html="drinkSet.content"></div>
      </Modal>
    </div>
    <div class="col-5 col-sm-2">{{drinkSet.price | currency}}</div>
    <div class="col-7 col-sm-3">
      <div class="input-group">
        <input :id="`drinkset-${drinkSet.id}`" type="number" min="0"  class="form-control" v-model="quantity" @input="onChange" inputmode="numeric">
        <div class="input-group-append">
          <span class="input-group-text">セット</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from '../Modal';

  export default {
    components: {
      Modal,
    },
    props: {
      drinkSet: Object,
      handleDrinkSet: Function,
      calculate: Function
    },
    data() {
      return {
        shouldShowDrinkSetModal: false,
        modalName: `drinkSet${this.drinkSet.id}`,
        quantity: ''
      }
    },
    methods: {
      show() {
        this.shouldShowDrinkSetModal = true;
      },
      hide() {
        this.shouldShowDrinkSetModal = false;
      },
      onChange() {
        const { name, price } = this.drinkSet
        const quantity = this.quantity
        this.$emit('handleDrinkSet', { name, price, quantity })
        this.$emit('calculate')
      }
    }
  }
</script>